var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.event)?_c(_vm.modalType,{tag:"component",attrs:{"related":_vm.related,"source":_vm.event},on:{"updateRelated":_vm.loadRelated,"close":_vm.close,"hasChanges":_vm.hasChanges}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }